import { round } from 'lodash';

import { ensureDefined } from '@e-socna/utils';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

import { useSIGDistanceExacteMissionAgenceEnKmAuPlusLong } from './useSIGDistanceExacteMissionAgenceEnKmAuPlusLong.resolver';

export const useSIGDistanceArrondieMissionAgenceEnKmAuPlusLong = (
  parameters: ResolverParameters,
): ResolverResult<number | string> => {
  const exactResult =
    useSIGDistanceExacteMissionAgenceEnKmAuPlusLong(parameters);

  if (!exactResult.isSuccess) {
    return {
      ...exactResult,
      data: undefined,
    };
  }

  const { data } = ensureDefined({
    data: exactResult.data,
  });

  return {
    data: {
      generated:
        typeof data.generated === 'string'
          ? data.generated
          : round(data.generated, 2),
    },
    error: null,
    isLoading: false,
    isSuccess: true,
  };
};
